import {
    SAVE_TRADE_RECON_COST,
    PRINT_TRADE_RECON_COST,
    UPDATE_TRADE_RECON_ITEMS,
    SAVE_AND_PRINT_TRADE_RECON_COST
} from '../actionTypes/tradeReconCostActionTypes';
import type { TradeReconData } from '../types/tradeReconCostTypes';

export const saveTradeReconCost = (payload: Record<string, TradeReconData>) => ({
    type: SAVE_TRADE_RECON_COST,
    payload
});

export const printTradeReconCost = () => ({
    type: PRINT_TRADE_RECON_COST
});

export const updateTradeReconItems = (payload: Record<string, TradeReconData>) => ({
    type: UPDATE_TRADE_RECON_ITEMS,
    payload
});

export const saveAndPrintTradeReconCost = (payload: Record<string, TradeReconData>) => ({
    type: SAVE_AND_PRINT_TRADE_RECON_COST,
    payload
});
